import makeThemedStyles from '../../components/Theme/makeThemedStyles';

const useStyles = makeThemedStyles(theme => ({
  home: {
    padding: theme.spacing(0, 1),
  },
}));

export default useStyles;
